import React from 'react';
import { Button, Image, Stack } from 'react-bootstrap';

const RegistrationCard = ({
	email,
	setEmail,
	emailTouched,
	setEmailTouched,
	isEmailValid,
	onRegister,
	imageSrc,
	heading,
	description,
	buttonLabel,
	buttonDisabled,
}: {
	email: string;
	setEmail: (val: string) => void;
	emailTouched: boolean;
	setEmailTouched: (val: boolean) => void;
	isEmailValid: boolean;
	onRegister: () => void;
	imageSrc: string;
	heading: React.ReactNode;
	description: React.ReactNode;
	buttonLabel: string;
	buttonDisabled: boolean;
}) => (
	<div className="for-employees-card text-center flex-1">
		<div className="d-flex flex-row gap-2">
			<input
				type="text"
				className={`rounded-pill form-control m-0 flex-1 shadow-none${emailTouched && email && !isEmailValid ? ' border-danger' : ''}`}
				placeholder="Email"
				value={email}
				onChange={(e) => setEmail(e.target.value)}
				onBlur={() => setEmailTouched(true)}
			/>
			<Button
				onClick={onRegister}
				className="filled-btn rounded-pill mx-auto opacity-100"
				disabled={buttonDisabled}
			>
				{buttonLabel}
			</Button>
		</div>
		<div className="for-employees-img">
			<Image src={imageSrc} className="w-auto" alt="employees-img" loading="lazy" />
		</div>
		<Stack className="for-employees-content">
			<h4 className="mb-0">{heading}</h4>
			{description}
		</Stack>
	</div>
);

export default RegistrationCard;
